document.addEventListener("DOMContentLoaded", function(){

// Labor tiers by quantity
function laborCost(qty){
 if(qty<=11) return 3;
 if(qty<=23) return 2.75;
 if(qty<=49) return 2.5;
 if(qty<=99) return 2;
 return 1.75;
}

// ================= JOB CALCULATOR =================
document.getElementById("runJob").addEventListener("click", function(){

try{

let garmentCost = parseFloat(document.getElementById("garment").value);
let garmentMarkupPct = parseFloat(document.getElementById("garmentMarkup").value)/100;

// Retail garment price used in calculations
let garment = garmentCost * (1 + garmentMarkupPct);
let locations = parseInt(document.getElementById("printSize").value);
let inkPerLocation = parseFloat(document.getElementById("inkPerLocation").value);
let darkInk = parseFloat(document.getElementById("garmentType").value);
let overhead = parseFloat(document.getElementById("overhead").value)/100;
let qty = parseInt(document.getElementById("customerQty").value);
let mins = parseFloat(document.getElementById("minutesPerShirt").value);
let margin = parseFloat(document.getElementById("mode").value);
let art = parseFloat(document.getElementById("artFee").value);
let rush = parseFloat(document.getElementById("rushFee").value)/100;


// Count print locations
let totalLocations = locations;
if(document.getElementById("secondLocation").checked) totalLocations++;
if(document.getElementById("sleevePrint").checked) totalLocations++;

// Labor
let extraLabor = document.getElementById("personalization").checked ? 3 : 0;
let labor = laborCost(qty) + extraLabor;

// COST PER SHIRT
let inkPer = (totalLocations * inkPerLocation) + darkInk;
let baseCost = garment + inkPer + labor;
let overheadPer = baseCost * overhead;
let trueCost = baseCost + overheadPer;

// SELL PRICE
let sell = trueCost/(1-margin);

// TOTALS
let subtotal = sell * qty;
let rushAmt = subtotal * rush;
let totalSell = subtotal + rushAmt + art;
let totalCost = trueCost * qty;




// Profit before discount
let profit = totalSell - totalCost - art;

// Shop cost = labor + overhead
let shopCostPerShirt = labor + overheadPer;

// 50% shop cost discount value
let maxDiscountPerShirt = shopCostPerShirt * 0.50;

// Check if discount is enabled
let discountEnabled = document.getElementById("applyMaxDiscount").checked;

let actualDiscountPerShirt = 0;
if(discountEnabled){
  actualDiscountPerShirt = maxDiscountPerShirt;
}

// Apply discount
let totalDiscount = actualDiscountPerShirt * qty;
profit -= totalDiscount;

let discountedPricePerShirt = sell - actualDiscountPerShirt;
let profitPerShirt = profit / qty;

// TIME & HOURLY METRICS
let hours = (mins * qty) / 60;
let profitHr = profit / hours;
let laborPerHour = labor * (60/mins);

// Enforce $100/hr goal
let adjusted = sell;
if(profitHr < 100){
 let required = 100 * hours;
 let needed = required + totalCost + art;
 adjusted = (needed - art) / qty;
}

// ================= REPORT OUTPUT =================
document.getElementById("results").textContent =

"Garment Cost: $" + garmentCost.toFixed(2) + "\n" +
"Garment Markup: " + (garmentMarkupPct*100).toFixed(0) + "%\n" +
"Garment Retail Price: $" + garment.toFixed(2) + "\n\n" +
"Ink: $" + inkPer.toFixed(2) + "\n" +
"--------------------------\n" +
"Hard Cost: $" + (garment + inkPer).toFixed(2) + "\n\n" +

"Labor: $" + labor.toFixed(2) + "\n" +
"Overhead: $" + overheadPer.toFixed(2) + "\n" +
"--------------------------\n" +
"Shop Costs: $" + (labor + overheadPer).toFixed(2) + "\n\n" +

"True Cost is hard cost + Shop Cost: $" + trueCost.toFixed(2) + "\n" +
"50% Shop Cost Discount Applied: $" + actualDiscountPerShirt.toFixed(2) + "\n\n" +

"Original Price: $" + sell.toFixed(2) + "\n" +
"Discounted Price: $" + discountedPricePerShirt.toFixed(2) + "\n" +
"Adjusted Price (to meet $100/hr): $" + adjusted.toFixed(2) + "\n\n" +

"Total Profit: $" + profit.toFixed(2) + "\n" +
"Profit Per Shirt: $" + profitPerShirt.toFixed(2) + "\n" +
"Profit / Hour: $" + profitHr.toFixed(2) + "\n\n" +

"Labor Cost / Hour: $" + laborPerHour.toFixed(2);

}catch(err){
 document.getElementById("results").textContent = "Error: " + err.message;
}

});

// ================= REVENUE PLANNER =================
document.getElementById("runPlan").addEventListener("click", function(){

let monthly = parseFloat(document.getElementById("monthlyGoal").value);
let days = parseInt(document.getElementById("workDays").value);
let hrs = parseFloat(document.getElementById("hoursPerDay").value);
let avg = parseInt(document.getElementById("avgJobSize").value);

let daily = monthly / days;
let weekly = daily * 5;
let shirts = weekly / 20;
let jobs = shirts / avg;
let capacity = (shirts / ((hrs*60/4)*5)) * 100;

document.getElementById("results").textContent +=

"\n\nREVENUE PLAN\n" +
"Daily Revenue Needed: $" + daily.toFixed(2) + "\n" +
"Jobs Per Week Needed: " + Math.ceil(jobs) + "\n" +
"Machine Capacity Used: " + capacity.toFixed(1) + "%";

});

});